var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_1595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 45C10 40.8643 13.3643 37.5 17.5 37.5C21.6357 37.5 25 40.8643 25 45H30C30 45 30 36.8493 30 36.8262C30 34.9583 32.1523 33.7298 33.7634 34.668C35.3877 35.6138 37.5 34.3815 37.5 32.5C37.5 30.6842 35.3592 29.393 33.7637 30.3319C32.1339 31.2909 30 30.0561 30 28.1738V15H7.5C3.36425 15 0 18.3643 0 22.5V45H10Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 70C25.8643 70 22.5 66.6357 22.5 62.5C22.5 58.3643 25.8643 55 30 55V50H21.825C19.9601 50 18.6969 47.895 19.6679 46.2355C20.6055 44.633 19.3925 42.5002 17.5002 42.5C15.6896 42.4999 14.3979 44.6443 15.3319 46.2352C16.292 47.8703 15.0667 50 13.1751 50H0V72.5C0 76.6357 3.36425 80 7.5 80H30V70Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 50C55 54.1357 51.6357 57.5 47.5 57.5C43.3643 57.5 40 54.1357 40 50H35V58.1738C35 60.047 32.8524 61.275 31.2366 60.3321C29.6219 59.3898 27.5001 60.616 27.5 62.4999C27.5 64.3224 29.6379 65.609 31.2365 64.668C32.8577 63.7138 35 64.9623 35 66.8262V80H57.5C61.6357 80 65 76.6357 65 72.5V50H55Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 0H47.5C46.1182 0 45 1.11817 45 2.5V13.1738C45 15.069 47.1308 16.2854 48.7645 15.3321C50.4004 14.3775 52.4999 15.638 52.5 17.4999C52.5001 19.3249 50.3659 20.6135 48.7648 19.6681C47.1412 18.7094 45 19.9624 45 21.8262V32.5C45 33.8818 46.1182 35 47.5 35H55C55 39.1357 58.3643 42.5 62.5 42.5C66.6357 42.5 70 39.1357 70 35H77.5C78.8818 35 80 33.8818 80 32.5V7.5C80 3.36425 76.6357 0 72.5 0Z",
    fill: "#AD186A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_1595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.de2b9f992d9693fdbaac7c0ef689d0a4.svg";
export { ForwardRef as ReactComponent };